module.exports = __webpack_public_path__ + "static/img/b12.df725b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b12.jpg
// module id = 5Bmy
// module chunks = 1